import { useTranslation } from "react-i18next";

/**
 * The RC / NIF / NIS / AI block printed under each party on an Algerian
 * invoice or purchase order. Labels are translated, the identifiers themselves
 * are not, so the same document reads correctly in French, Arabic or English.
 *
 * Renders nothing when the party has no identifiers recorded, which keeps the
 * layout clean for companies outside Algeria.
 */
export default function LegalIdentifierLines({ party, style, compact = false }) {
  const { t } = useTranslation();

  if (!party) return null;

  const lines = [
    { label: t('legal.rc'), value: party.registration_number },
    { label: t('legal.nif'), value: party.tax_id },
    { label: t('legal.nis'), value: party.nis },
    { label: t('legal.taxArticle'), value: party.tax_article },
  ].filter(line => line.value);

  if (lines.length === 0) return null;

  const baseStyle = {
    fontSize: compact ? 11 : 12,
    color: "#777",
    marginTop: 6,
    lineHeight: 1.7,
    ...style,
  };

  return (
    <div style={baseStyle}>
      {lines.map(line => (
        <div key={line.label}>
          <span style={{ color: "#999" }}>{line.label} : </span>
          {line.value}
        </div>
      ))}
    </div>
  );
}
